/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

export const SET_DATA = Symbol('set-data');
export const UPDATE_DOCUMENT = Symbol('update-document');
export const ADD_NEW_BIOSAMPLE_CODE = Symbol('add-item-id');
export const UPDATE_BIOSAMPLE_CODE = Symbol('update-item-id');
export const REMOVE_BIOSAMPLE_CODE = Symbol('remove-item-id');
export const SIGNED_DOCUMENT = 'signed';
export const DECLINED_DOCUMENT = 'declined';
export const REMOVE = Symbol('remove');
export const UPDATE = Symbol('update');
export const UNIQUE_ID_ERROR_STATUS_CODE = 409;
